import {
	environment
} from "src/environments/environment";

export class DialogData {
	public size: string;
	public type: string;
	public title: string;
	public contents: string[];
	public buttons: any;
	public disableCloseButton: boolean;

	private _errorDetail: string = null;
	private _errorMessage: string = null;

	constructor(data) {
		this.size = data.size;
		this.type = data.type;
		this.title = data.title;
		this.contents = data.contents;
		this.buttons = data.buttons;
		this.disableCloseButton = data.disableCloseButton;

		this._errorDetail = data.errorDetail;
		this._errorMessage = data.errorMessage;
	}

	public static fromPreset(presetName: string, params?): DialogData {
		if (modals[presetName]) return new modals[presetName](params);
		if (!dialogPresets[presetName]) throw "Dialog preset not found.";

		return new DialogData(dialogPresets[presetName]);
	}

	public get errorMessage(): string {
		return this._errorMessage || this.getContent();
	}

	public get errorDetail(): string {
		return this._errorDetail;
	}

	private getContent(): string {
		return this.contents.map(s => s.replace(/<\/?p[^>]*>/g, '')).join(' ');
	}
}

class ModalExistsBankbilletConsulta extends DialogData {

	constructor({
		classificationName
	}) {
		super({
			size: 'MEDIUM',
			type: 'warn',
			title: 'Produto similar adquirido',
			contents: [
				'<p>Identificamos que você já possui um boleto em aberto para o <b>Consulta e Cobrança de Dívidas</b>, que inclui serviços semelhantes ao plano de Assinatura.</p>',
				'<br>',
				'<p>Deseja cancelar o pedido anterior e prosseguir com essa assinatura? </p>'
			],
			buttons: {
				'primary': {
					title: 'Sim',
					action: 'doCheckoutInThisPlan',
				},
				'secondary': {
					title: 'Não',
					action: 'redirect',
					callToAction: environment.serasaHomePage
				}
			},
			disableCloseButton: true
		});
	}
}

class ModalExistsPixConsulta extends DialogData {

	constructor({
		classificationName
	}) {
		super({
			size: 'MEDIUM',
			type: 'warn',
			title: 'Produto similar adquirido',
			contents: [
				'<p>Identificamos que você já possui um PIX em aberto para o <b>Consulta e Cobrança de Dívidas</b>, que inclui serviços semelhantes ao plano de Assinatura.</p>',
				'<br>',
				'<p>Deseja cancelar o pedido anterior e prosseguir com essa assinatura? </p>'
			],
			buttons: {
				'primary': {
					title: 'Sim',
					action: 'doCheckoutInThisPlan',
				},
				'secondary': {
					title: 'Não',
					action: 'redirect',
					callToAction: environment.serasaHomePage
				}
			},
			disableCloseButton: true
		});
	}
}

class ModalExistsBankbilletMensalPlan extends DialogData {
	constructor({
		classificationName
	}) {
		super({
			size: 'MEDIUM',
			type: 'warn',
			title: 'Produto similar adquirido',
			contents: [
				'<p>Identificamos que você já possui um boleto em aberto para o <b>Assinatura</b>, que inclui serviços semelhantes ao plano desejado.</p>',
				'<br>',
				'<p>Deseja cancelar o pedido anterior e prosseguir com essa assinatura? </p>'
			],
			buttons: {
				'primary': {
					title: 'Sim',
					action: 'doCheckoutInThisPlan',
				},
				'secondary': {
					title: 'Não',
					action: 'redirect',
					callToAction: environment.serasaHomePage
				}
			},
			disableCloseButton: true
		});
	}
}

class ModalExistsPixMensalPlan extends DialogData {
	constructor({
		classificationName
	}) {
		super({
			size: 'MEDIUM',
			type: 'warn',
			title: 'Produto similar adquirido',
			contents: [
				'<p>Identificamos que você já possui um PIX em aberto para o <b>Assinatura</b>, que inclui serviços semelhantes ao plano desejado.</p>',
				'<br>',
				'<p>Deseja cancelar o pedido anterior e prosseguir com essa assinatura? </p>'
			],
			buttons: {
				'primary': {
					title: 'Sim',
					action: 'doCheckoutInThisPlan',
				},
				'secondary': {
					title: 'Não',
					action: 'redirect',
					callToAction: environment.serasaHomePage
				}
			},
			disableCloseButton: true
		});
	}
}

class ModalExistsBankbilletSDSN extends DialogData {
	constructor({
		businessId,
		userId
	}) {
		super({
			size: 'MEDIUM',
			type: 'warn',
			title: 'Produto similar adquirido',
			contents: [
				'<p>Identificamos que você já possui um boleto em aberto para o <b>Saúde do seu Negócio</b>, que inclui serviços semelhantes ao plano de Assinatura.</p>',
				'<br>',
				'<p>Deseja cancelar o pedido anterior e prosseguir com essa assinatura? </p>'
			],
			buttons: {
				'primary': {
					title: 'Sim',
					action: 'doCheckoutInThisPlan',
				},
				'secondary': {
					title: 'Não',
					action: 'redirect',
					callToAction: environment.ecommerce_base_url + `/auto-atendimento/alteracao-de-pagamento?businessId=` + businessId + `&userId=` + userId
				}
			},
			disableCloseButton: true
		});
	}
}

class ModalExistsPixSDSN extends DialogData {
	constructor({
		businessId,
		userId
	}) {
		super({
			size: 'MEDIUM',
			type: 'warn',
			title: 'Produto similar adquirido',
			contents: [
				'<p>Identificamos que você já possui um PIX em aberto para o <b>Saúde do seu Negócio</b>, que inclui serviços semelhantes ao plano de Assinatura.</p>',
				'<br>',
				'<p>Deseja cancelar o pedido anterior e prosseguir com essa assinatura? </p>'
			],
			buttons: {
				'primary': {
					title: 'Sim',
					action: 'doCheckoutInThisPlan',
				},
				'secondary': {
					title: 'Não',
					action: 'redirect',
					callToAction: environment.ecommerce_base_url + `/auto-atendimento/alteracao-de-pagamento?businessId=` + businessId + `&userId=` + userId
				}
			},
			disableCloseButton: true
		});
	}
}

class ModalExistsBankbilletMonitore extends DialogData {
	constructor({
		businessId,
		userId
	}) {
		super({
			size: 'MEDIUM',
			type: 'warn',
			title: 'Produto similar adquirido',
			contents: [
				'<p>Identificamos que você já possui um boleto em aberto para o <b>Monitore Clientes</b>, que inclui serviços semelhantes ao plano de assinatura.</p>',
				'<br>',
				'<p>Deseja cancelar o pedido anterior e prosseguir com essa assinatura?</p>'
			],
			buttons: {
				'primary': {
					title: 'Sim',
					action: 'doCheckoutInThisPlan',
				},
				'secondary': {
					title: 'Não',
					action: 'redirect',
					callToAction: environment.ecommerce_base_url + `/auto-atendimento/monitore-clientes/alteracao-de-pagamento?businessId=` + businessId + `&userId=` + userId
				}
			},
			disableCloseButton: true
		})
	}
}
class TrustConsultationModal extends DialogData {
	constructor({ message }) {
		super({
			size: 'MEDIUM',
			type: 'error',
			title: 'Você não pode consumir este produto nesse momento',
			buttons: {
				'primary': {
					title: 'Voltar',
					action: 'redirect',
					callToAction: 'https://www.serasaempreendedor.com.br/v2/home'
				}
			},
			disableCloseButton: true
		});

	}
}
class ModalExistsPixMonitore extends DialogData {
	constructor({
		businessId,
		userId
	}) {
		super({
			size: 'MEDIUM',
			type: 'warn',
			title: 'Produto similar adquirido',
			contents: [
				'<p>Identificamos que você já possui um PIX em aberto para o <b>Monitore Clientes</b>, que inclui serviços semelhantes ao plano de assinatura.</p>',
				'<br>',
				'<p>Deseja cancelar o pedido anterior e prosseguir com essa assinatura?</p>'
			],
			buttons: {
				'primary': {
					title: 'Sim',
					action: 'doCheckoutInThisPlan',
				},
				'secondary': {
					title: 'Não',
					action: 'redirect',
					callToAction: environment.ecommerce_base_url + `/auto-atendimento/monitore-clientes/alteracao-de-pagamento?businessId=` + businessId + `&userId=` + userId
				}
			},
			disableCloseButton: true
		})
	}
}

class ProductDisabled extends DialogData {
	constructor({
		enableProducts
	}) {
		super({
			size: 'CUSTOM_INVALID_PRODUCT',
			type: 'warn',
			title: 'Produto indisponível no momento.',
			contents: [],
			buttons: {
				'primary': {
					title: 'Voltar',
					action: 'close'
				}
			}
		});

		let content;

		enableProducts = enableProducts.filter((e) => {
			return e.cardTitle !== "Mensal";
		});
		if (enableProducts.length) {
			let automaticRechargeValue = enableProducts[0].product.automaticRecharge;
			let automaticRecharge = Number.isInteger(automaticRechargeValue) ? automaticRechargeValue : automaticRechargeValue.toFixed(2).replace('.', ',');
			let plural = (enableProducts.length === 1) ? false : true;

			if (plural) {
				content = 'Os pacotes ' + this.getEnableProductsString(enableProducts) + ' são os únicos disponíveis para você. ';
			} else {
				content = 'O pacote ' + this.getEnableProductsString(enableProducts) + ' é o único disponível para você. ';
			}

			content += 'Para escolher outro pacote, seu crédito deve ser igual ou menor que R$' + automaticRecharge + '.'
		} else {
			content = 'O pacote desejado encontra-se indisponível, por favor selecione outra opção.';
		}

		this.contents = [
			'<p>' + content + '</p>'
		]
	}

	private getEnableProductsString(enableProducts): string {
		let content = "";

		enableProducts.forEach((ep, index) => {
			let last = (index === enableProducts.length - 1) ? true : false;
			if (index > 0) {
				if (last) {
					content += ` e R$ ${ep.baseValue}`;
				} else {
					content += `, R$ ${ep.baseValue}`;
				}
			} else {
				content += `R$ ${ep.baseValue}`;
			}
		})

		return content;
	}
}

class FraudnetReject extends DialogData {
	constructor({
		customErrorKey
	}) {
		let buttons = {
			'primary': {
				title: 'Sim',
				action: 'changeToBankBillet'
			},
			'secondary': {
				title: 'Não',
				action: 'disableCreditCard',
				callToAction: null
			}
		};

		let size = "MEDIUM";

		let contents = [
			"<p>O pagamento com cartão de crédito não está disponível para esta compra.</p>",
			"<br>",
			"<p><b> Deseja efetuar o pagamento com boleto ou pix? </b></p>"
		];

		if (customErrorKey === "paymentChangeError") {
			contents = [
				"<p>Há um problema com o cartão de crédito informado e a alteração do pagamento não pode ser concluída.</p>",
				"<br>",
				"<p><b>Entre em contato com nosso time de suporte ou continue o pagamento via boleto.<b></p>"
			];

			size = "500px";

			buttons.primary.title = "Continuar com boleto";

			buttons.secondary = {
				title: "Conversar com suporte",
				action: "redirect",
				callToAction: "https://ajuda.pmedigital.serasaexperian.com.br/hc/pt-br/requests/new"
			};
		}

		super({
			type: 'info',
			title: 'Cartão indisponível',
			size,
			contents,
			buttons,
			disableCloseButton: true
		})
	}
}

class WatchlistReject extends DialogData {
	constructor({
		customErrorKey
	}) {
		super({
			type: 'error',
			title: 'Não podemos finalizar sua compra!',
			size: "MEDIUM",
			contents: [
				"<p>No momento as nossas soluções não atendem as particularidades da sua empresa. </p>",
				"<br>",
				"<p>Estamos trabalhando para disponibilizar nossas soluções em breve.</p>",
			],
			buttons: {
				'primary': {
					title: 'Sair',
					action: 'redirect',
					callToAction: environment.serasaHomePage
				}
			},
			disableCloseButton: true
		})
	}
}

class DiscountModal extends DialogData {
	constructor({
		customMessage
	}) {
		let content = [];
		if (!customMessage || customMessage === "") {
			content.push(
				"<p>Você acaba de ganhar <b>10% de desconto</b> para finalizar sua compra agora.</p>" +
				"<br>" +
				"<p>Para utilizar, basta clicar no botão abaixo. Aproveite essa oportunidade agora mesmo!</p>"
			);
		} else {
			content.push(customMessage);
		}


		super({
			size: "MEDIUM",
			type: "success",
			title: `Espere um instante, temos um presente para você!`,
			contents: content,
			buttons: {
				primary: {
					title: "Aproveitar esse desconto incrível",
					action: "applyModalCoupon"
				},
			},
			disableCloseButton: false,
		})
	}
}
class ModalDeleteCreditCard extends DialogData {
	constructor({
	}) {
		super({
			size: 'MEDIUM',
			type: 'warn',
			title: 'Deseja excluir esse cartão?',
			contents: [
				`Importante: as compras com renovações automáticas realizadas utilizando este cartão, ainda <b>serão processadas normalmente.</b> Para alterar o cartão ou forma de pagamento, acesse o <a href="${environment.serasaHomePage.split('/v2/home')[0]}/auto-servico/painel-de-controle" target="blank" class="as"> Painel de Controle.</a>`
			],
			buttons: {
				'primary': {
					title: 'Sim',
					action: 'doDeleteCreditCard',
				},
				'secondary': {
					title: 'Cancelar',
					action: 'close',
				}
			},
			disableCloseButton: true
		});
	}
}


enum PresetNames {
	MODAL_EXISTS_BANKBILLET_MENSAL_PLAN = "MODAL_EXISTS_BANKBILLET_MENSAL_PLAN",
	MODAL_EXISTS_BANKBILLET_SDSN = "MODAL_EXISTS_BANKBILLET_SDSN",
	MODAL_EXISTS_BANKBILLET_MONITORE = "MODAL_EXISTS_BANKBILLET_MONITORE",
	productDisabled = "productDisabled",
	FraudnetReject = "FRAUDNET_REJECT",
	WatchlistRejectPix = "WATCHLIST_REJECT_PIX",
	WatchlistRejectBoleto = "WATCHLIST_REJECT_BOLETO",
	WatchlistRejectCreditCard = "WATCHLIST_REJECT_CREDITCARD",
	MODAL_EXISTS_PIX_MENSAL_PLAN = "MODAL_EXISTS_PIX_MENSAL_PLAN",
	MODAL_EXISTS_PIX_SDSN = "MODAL_EXISTS_PIX_SDSN",
	MODAL_EXISTS_PIX_MONITORE = "MODAL_EXISTS_PIX_MONITORE",
	MODAL_EXISTS_PIX_CONSULTA = "MODAL_EXISTS_PIX_CONSULTA",
	MODAL_EXISTS_BANKBILLET_CONSULTA = "MODAL_EXISTS_BANKBILLET_CONSULTA",
	MODAL_DISCOUNT = "MODAL_DISCOUNT",
	MODAL_DELETE_CREDIT_CARD = "MODAL_DELETE_CREDIT_CARD",
	TRUST_CONSULTATION = "TRUST_CONSULTATION"
}

const modals = {
	[PresetNames.MODAL_EXISTS_BANKBILLET_CONSULTA]: ModalExistsBankbilletConsulta,
	[PresetNames.MODAL_EXISTS_PIX_CONSULTA]: ModalExistsPixConsulta,
	[PresetNames.MODAL_EXISTS_BANKBILLET_MENSAL_PLAN]: ModalExistsBankbilletMensalPlan,
	[PresetNames.MODAL_EXISTS_BANKBILLET_MONITORE]: ModalExistsBankbilletMonitore,
	[PresetNames.MODAL_EXISTS_BANKBILLET_SDSN]: ModalExistsBankbilletSDSN,
	[PresetNames.productDisabled]: ProductDisabled,
	[PresetNames.FraudnetReject]: FraudnetReject,
	[PresetNames.WatchlistRejectPix]: WatchlistReject,
	[PresetNames.WatchlistRejectBoleto]: WatchlistReject,
	[PresetNames.WatchlistRejectCreditCard]: WatchlistReject,
	[PresetNames.MODAL_EXISTS_PIX_MENSAL_PLAN]: ModalExistsPixMensalPlan,
	[PresetNames.MODAL_EXISTS_PIX_MONITORE]: ModalExistsPixMonitore,
	[PresetNames.MODAL_EXISTS_PIX_SDSN]: ModalExistsPixSDSN,
	[PresetNames.MODAL_DELETE_CREDIT_CARD]: ModalDeleteCreditCard,
	[PresetNames.TRUST_CONSULTATION]: TrustConsultationModal
}

const dialogPresets = {
	"invalidChecksum": {
		size: 'MEDIUM',
		type: 'error',
		title: 'Falha de comunicação',
		contents: [
			`<p> Infelizmente não conseguimos prosseguir com a sua compra, clique no voltar e tente novamente </p>`
		],
		buttons: {
			'primary': {
				title: 'Voltar',
				action: 'redirect',
				callToAction: environment.serasaHomePage
			}
		}
	},
	"RECENT_PURCHASE_MODAL": {
		size: 'MEDIUM',
		type: 'shopping',
		title: 'Deseja seguir com a compra?',
		contents: [
			`<p>Percebemos que você comprou esse produto há poucos minutos.</p>`,
			'<br>',
			'<p>Deseja fazer uma nova compra agora?</p>'
		],
		buttons: {
			'primary': {
				title: 'Sim',
				action: 'doCheckout',
			},
			'secondary': {
				title: 'Não',
				action: 'close'
			}
		},
		disableCloseButton: true
	},
	"MODAL_FRAUDNET_PENDING_PURCHASE": {
		size: 'MEDIUM',
		type: 'info',
		title: 'Seu pedido está em análise',
		contents: [
			'<p>Identificamos que você já fez essa compra e seu pedido está em análise</p>',
			'<br>',
			'<p>Não se preocupe: o prazo máximo para conclusão é de até 6 horas e avisaremos pro e-mail assim que o status for atualizado :)</p>'
		],
		buttons: {
			'primary': {
				title: 'Ok, entendi',
				action: 'redirect',
				callToAction: environment.serasaHomePage
			}
		},
		disableCloseButton: true
	},
	"MODAL_WATCHLIST_PENDING_PURCHASE": {
		size: 'MEDIUM',
		type: 'info',
		title: 'Seu pedido está em análise  - VERSÃO WATCHLIST',
		contents: [
			'<p>Identificamos que você já fez essa compra e seu pedido está em análise</p>',
			'<br>',
			'<p>Não se preocupe: o prazo máximo para conclusão é de até 6 horas e avisaremos pro e-mail assim que o status for atualizado :)</p>'
		],
		buttons: {
			'primary': {
				title: 'Ok, entendi',
				action: 'redirect',
				callToAction: environment.serasaHomePage
			}
		},
		disableCloseButton: true
	},
	"productDisabledError": {
		size: 'MEDIUM',
		type: 'warn',
		title: 'Estamos processando sua compra.',
		contents: [
			'<p>Em breve você poderá acessar os produtos adquiridos.</p>'
		],
		buttons: {
			'primary': {
				title: 'Voltar',
				action: 'redirect',
				callToAction: 'https://www.serasaempreendedor.com.br/v2/home'
			}
		}
	},
	"checksum": {
		size: 'MEDIUM',
		type: 'error',
		title: 'Foi identificado um erro inesperado em nosso sistema.',
		contents: [
			'<p>Por favor, faça o login novamente para finalizar sua compra.</p>'
		],
		buttons: {
			'primary': {
				title: 'Voltar',
				action: 'redirect',
				callToAction: window.location.href
			}
		},
		disableCloseButton: true
	},
	"mitigated": {
		size: 'MEDIUM',
		type: 'error',
		title: 'Não podemos finalizar sua compra!',
		contents: [
			`<p>Foi identificado uma possível inconsistência no CNPJ cadastrado ou CPF sem participação na empresa.</p>`,
			'<br>',
			`<p>Acesse a nossa <a href="https://ajuda.pmedigital.serasaexperian.com.br/hc/pt-br/requests/new">Central de atendimento</a> para mais informações.</p>`
		],
		buttons: {
			'primary': {
				title: 'Voltar',
				action: 'redirect',
				callToAction: 'https://www.serasaempreendedor.com.br/v2/home'
			}
		},
		disableCloseButton: true,
		errorDetail: "DIGITAL_USER_MITIGATED",
		errorMessage: "Existe alguma inconsistência no CNPJ cadastrado ou o seu CPF não foi identificado como sócio da empresa."
	},
	"IDENTITY_ERROR": {
		size: 'MEDIUM',
		type: 'error',
		title: 'Não podemos finalizar sua compra!',
		contents: [
			`<p>Foi identificado que sua empresa se enquadra em uma das situações abaixo, por favor verifique:</p>`,
			'<br>',
			`<p>1. Empresa Inativa na receita federal</p>`,
			`<p>2. Ramos de atividades não comercializáveis</p>`,
			`<p>3. Empresa com apontamentos de inconsistência do Serasa Experian</p>`,
			'<br>',
			`<p>Acesse a nossa <a href="https://serasaempreendedor.zendesk.com/hc/pt-br/requests/new">Central de atendimento</a> para mais informações.</p>`
		],
		buttons: {
			'primary': {
				title: 'Recuperar meu usuário',
				action: 'redirect',
				callToAction: 'https://serasaempreendedor.zendesk.com/hc/pt-br/requests/new'
			},
			'secondary': {
				title: 'Voltar',
				action: 'close'
			}
		}
	},
	"DEFAULT_ERROR": {
		size: 'MEDIUM',
		type: 'error',
		title: 'Serviço indisponível no momento.',
		contents: [
			`<p>Por favor, tente novamente mais tarde.</p>`,
		],
		buttons: {
			'primary': {
				title: 'Voltar',
				action: 'close'
			}
		}
	},
	"discountModal": {
		size: "MEDIUM",
		type: "success",
		title: `Espere um instante, temos um presente para você!`,
		contents: [
			"<p>Você acaba de ganhar <b>10% de desconto</b> para finalizar sua compra agora.</p>",
			"<br>",
			"<p>Para utilizar, basta clicar no botão abaixo. Aproveite essa oportunidade agora mesmo!</p>"
		],
		buttons: {
			primary: {
				title: "Aproveitar esse desconto incrível",
				action: "applyModalCoupon"
			},
		},
		disableCloseButton: false,
	},
	"processingPurchase": {
		size: "MEDIUM",
		type: "warn",
		title: 'Estamos processando sua compra.',
		contents: [
			"<p>Seu pagamento foi realizado com sucesso! Tente acessar o produto adquirido em alguns instantes.</p>",
			"<br>"
		],
		buttons: {
			primary: {
				title: "Ok",
				action: "close"
			},
		}
	}
}


// const modals = [
//     "MODAL_EXISTS_BANKBILLET_MENSAL_PLAN",
//     "MODAL_EXISTS_BANKBILLET_SDSN",
//     "MODAL_EXISTS_BANKBILLET_MONITORE",
//     "productDisabled",
//     "invalidChecksum",
//     "RECENT_PURCHASE_MODAL",
//     "MODAL_FRAUDNET_PENDING_PURCHASE",
//     "FRAUDNET_REJECT",
//     "processingPurchase",
//     "checksum",
//     "mitigated",
//     "IDENTITY_ERROR",
//     'DEFAULT_ERROR',
//     "discountModal"
// ];
